/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Ex_TitleInputs */

const en_minifier_ex_title = /** @type {(inputs: Minifier_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minifying a nested object`)
};

const ko_minifier_ex_title = /** @type {(inputs: Minifier_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중첩 객체 압축하기`)
};

const ja_minifier_ex_title = /** @type {(inputs: Minifier_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネストしたオブジェクトを圧縮する`)
};

/**
* | output |
* | --- |
* | "Minifying a nested object" |
*
* @param {Minifier_Ex_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_ex_title = /** @type {((inputs?: Minifier_Ex_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Ex_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_ex_title(inputs)
	if (locale === "ko") return ko_minifier_ex_title(inputs)
	return ja_minifier_ex_title(inputs)
});